import Rollbar from "rollbar";

export const RollbarErrorTracking = (() => {
  const RollbarObj = new Rollbar({
    accessToken: process.env.REACT_APP_ROLLBAR_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: process.env.REACT_APP_ROLLBAR_ENVIRONMENT,
    captureUsername: true,
  });

  RollbarObj.configure({
    payload: {
      person: {
        id: sessionStorage.getItem("lgId"), // required
      },
    },
  });
  const logErrorInRollbar = (error: string = "An error Occurred", level: string = "error") => {
    try {
      switch (level) {
        case "error":
          RollbarObj.error(error);
          break;

        case "critical":
          RollbarObj.critical(error);
          break;

        case "warning":
          RollbarObj.warning(error);
          break;

        case "info":
          RollbarObj.info(error);
          break;

        case "debug":
          RollbarObj.debug(error);
          break;
        default:
          RollbarObj.error(error);
      }
    } catch {
      console.error(error);
    }
  };
  return { logErrorInRollbar };
})();

export default RollbarErrorTracking;
